import React from 'react';
import { Lock, MessageCircle } from 'lucide-react';
import { Card, Button } from './ui';
import { motion } from 'framer-motion';

export function UnavailableModule() {
  return (
    <div className="flex items-center justify-center min-h-[60vh] p-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="max-w-md w-full"
      >
        <Card className="text-center p-8">
          <div className="w-20 h-20 bg-purple/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <Lock size={40} className="text-purple" />
          </div>
          
          <h2 className="text-2xl font-bold mb-3">Módulo indisponível</h2>
          <p className="text-muted mb-6 leading-relaxed">
            Este recurso será liberado após o início das aulas e a geração dos primeiros registros acadêmicos.
          </p>

          <div className="bg-purple/5 border border-purple/10 rounded-2xl p-4 mb-8">
            <p className="text-sm font-medium text-purple">
              Status: Aguardando início do período letivo.
            </p>
          </div>

          <div className="space-y-3">
            <p className="text-xs text-muted mb-4 italic">
              "Todos os horários, avisos, comunicados e atividades acadêmicas são divulgados através do Discord oficial da instituição."
            </p>
            <Button className="w-full flex items-center justify-center gap-2">
              <MessageCircle size={18} />
              Acompanhar no Discord
            </Button>
          </div>
        </Card>
      </motion.div>
    </div>
  );
}
